import React from 'react';
import Introduction from './introduction';
import SolutionsGif from './SolutionsGif';
import ContactCTA from './ContactCTA';

function Home() {
  return (
    <div className="home">
      <Introduction />
      <SolutionsGif />
      <ContactCTA />
    </div>
  );
}

export default Home;